import React, { useState } from "react";

import { IMaskInput } from "react-imask";

function CepMaskedInput(props) {
  const { inputRef, defaultValue, ...other } = props;
  const [value, setValue] = useState(defaultValue);

  return (
    <IMaskInput
      {...other}
      inputRef={(ref) => inputRef(ref ? ref : null)}
      mask="000.000.000-00"
      unmask
      value={value}
      onAccept={(value, mask) => setValue(value)}
    />
  );
}

export default CepMaskedInput;
